__turbopack_context__.v({
  "colorDot": "ColorVariantSwitcher-module-scss-module__9ckdzW__colorDot",
  "colorName": "ColorVariantSwitcher-module-scss-module__9ckdzW__colorName",
  "container": "ColorVariantSwitcher-module-scss-module__9ckdzW__container",
  "currentColor": "ColorVariantSwitcher-module-scss-module__9ckdzW__currentColor",
  "header": "ColorVariantSwitcher-module-scss-module__9ckdzW__header",
  "imageSwatch": "ColorVariantSwitcher-module-scss-module__9ckdzW__imageSwatch",
  "imageWrapper": "ColorVariantSwitcher-module-scss-module__9ckdzW__imageWrapper",
  "label": "ColorVariantSwitcher-module-scss-module__9ckdzW__label",
  "selected": "ColorVariantSwitcher-module-scss-module__9ckdzW__selected",
  "selectionRing": "ColorVariantSwitcher-module-scss-module__9ckdzW__selectionRing",
  "singleColor": "ColorVariantSwitcher-module-scss-module__9ckdzW__singleColor",
  "strikethrough": "ColorVariantSwitcher-module-scss-module__9ckdzW__strikethrough",
  "swatch": "ColorVariantSwitcher-module-scss-module__9ckdzW__swatch",
  "swatchImage": "ColorVariantSwitcher-module-scss-module__9ckdzW__swatchImage",
  "swatches": "ColorVariantSwitcher-module-scss-module__9ckdzW__swatches",
  "unavailable": "ColorVariantSwitcher-module-scss-module__9ckdzW__unavailable",
  "vertical": "ColorVariantSwitcher-module-scss-module__9ckdzW__vertical",
});
